module.exports = __webpack_public_path__ + "static/media/snooze.78e8c5c9.svg";